import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { toTruthyList } from 'utils/array';

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-xxs'],
    },
  },
});

function extractTruthyClasses(classMaps: Record<string, boolean>): string[] {
  return toTruthyList(
    Object.entries(classMaps).map(([className, shouldAdd]) => (shouldAdd ? className : null)),
  );
}

export function classes(
  ...classNames: (string | null | undefined | Record<string, boolean>)[]
): string {
  const validNames = toTruthyList(classNames)
    .map((classDefinition) =>
      typeof classDefinition === 'string'
        ? classDefinition.trim() || []
        : extractTruthyClasses(classDefinition),
    )
    .flat()
    .join(' ');

  return validNames;
}

export function cn(...inputs: ClassValue[]): string {
  return customTwMerge(clsx(inputs));
}
